<template>
  <div
    class="regulatory-contract"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="seq" title="序号" width="50" align="center"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'contractStatus'">{{
              translateStatus(row.contractStatus)
            }}</template>
            <template v-else-if="item.field === 'spaceType'">{{
              translateSpaceType(row.spaceType)
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 撤回弹框 -->
    <WithdrawalDialog
      ref="withdrawalDialogRef"
      :withdrawalType="withdrawalType"
      @refreshTable="resetBtnClick"
    />
    <!-- 审批弹框 -->
    <ApprovalDialog ref="approvalDialogRef" @refreshTable="resetBtnClick" />
    <!-- 关闭合同提示 -->
    <CloseContractDialog ref="closeContractDialogRef" @refreshTable="closeContractHandler" />
    <!-- 变更主体提示 -->
    <ChangPrimaryDialog ref="changPrimaryDialogRef" @refreshTable="closeContractHandler" />
  </div>
</template>

<script>
  import superviseContractMixin from './../superviseContractMixin.js';
  import { searchFormColumns, baseColumnListDefault } from './index.js';
  import tableBtnMixin from './tableBtnMixin';
  import leaseContractApi from '@/api/park/leaseContract';
  import WithdrawalDialog from './components/WithdrawalDialog/index.vue';
  import ApprovalDialog from './components/ApprovalDialog/index.vue';
  import CloseContractDialog from './components/CloseContractDialog/index.vue';
  import ChangPrimaryDialog from './components/ChangPrimaryDialog/index.vue';
  export default {
    mixins: [superviseContractMixin, tableBtnMixin],
    name: 'LeaseContract',
    data() {
      return {
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        menuButtonList: [], // 表格功能按钮
        query: {
          contractNo: '',
          storageCompanyNo: '',
          contractStatus: '',
          partnerName: '',
          partnerCode: '',
          superviseContractNo: '',
          leaseTerm: '',
          leaseDateFrom: '',
          leaseDateUnit: '',
          paperContractNo: '',
        },
        contractStatusList: [], // 合同状态
        spaceTypeList: [], // 空间类型
        columnList: [],
        loading: false,
        selectionList: [],
        isLoading: false,
        changeRowData: null,
        isCreate: true,
        isPaid: true,
      };
    },
    computed: {
      //表单字段
      searchColumns() {
        return searchFormColumns(this);
      },
    },
    mounted() {
      this.contractStatusList = this.dictListMap?.SuperviseContractStatusType1 || [];
      this.spaceTypeList = this.dictListMap.LeaseContractSpaceType; // 空间类型
      this.getButtonList();
      this.getTableData();
    },
    methods: {
      handleSelectionChange(row) {
        console.log(row, '选择行');
        this.selectionList = row;
      },
      // 根据合同号获取结算单列表
      async getSettlementList() {
        const rowData = this.selectionList[0];
        if (rowData.contractNo) {
          const { data } = await this.$axios.post(leaseContractApi.QUERY_SETTLEMENT_LIST, {
            contractNo: rowData.contractNo,
          });
          if (!data.data.length) {
            this.isCreate = false;
          } else {
            data.data.map((item) => {
              if (item.settlementIssueStatus != '01' || item.receiveStatus != '01') {
                this.isPaid = false;
              }
            });
          }
          console.log('data获取结算单列表', data);
        }
      },
      closeContractHandler() {
        // 判断当前是否为变更主体的时候
        // if (this.changeRowData) {
        //   // 路由直接跳转
        //   const path = {
        //     path: `/park/leaseContract/leaseDetail`,
        //     name: 'leaseDetail',
        //     meta: {
        //       keepAlive: false,
        //       title: '三方仓库租赁合同维护',
        //     },
        //     query: {
        //       status: 'change',
        //       id: this.changeRowData.id,
        //     },
        //   };
        //   this.changeRowData = null;
        //   this.$store.dispatch('tagsView/addTabView', path).then(() => {
        //     this.$nextTick(() => {
        //       this.$router.push(path);
        //     });
        //   });
        // }
        this.resetBtnClick();
      },
      // 搜索
      searchBtnClick() {
        console.log(this.query, '搜索');
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(baseColumnListDefault).then(() => {
          this.columnList = baseColumnListDefault;
        });
      },
      //双击事件
      dblclickEvent({ row }) {
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        const { contractStatus, contractNo, id } = row;
        console.log(row, '双击行', contractStatus, contractNo, id);
        const name = 'leaseDetail';
        const path = {
          path: `/park/leaseContract/${name}`,
          name: name,
          meta: {
            keepAlive: false,
            title: '三方仓库租赁合同维护',
          },
          query: {
            status: 'detail',
            contractNo: contractNo ? contractNo : '',
            id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 表单中事件
      changeMethod({ val, prop }) {
        console.log(val, prop, '触发');
        const selectRowData = (val && val[0]) || {};
        if (prop == 'partnerCode') {
          this.query.partnerCode = selectRowData.partnerCode;
        } else if (prop == 'partnerName') {
          this.query.partnerName = selectRowData.partnerZhName;
        }
      },
      // 翻译表格状态 contractStatusList
      translateStatus(status) {
        return this.contractStatusList.find((item) => item.value == status)?.label;
      },
      translateSpaceType(status) {
        return this.spaceTypeList.find((item) => item.value == status)?.label;
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      async getTableData() {
        console.log('获取表单数据1');
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        this.isLoading = true;
        const postData = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const {
          data: { code, data },
        } = await this.$axios.post(leaseContractApi.GET_PAGE_DAT, postData);
        this.isLoading = false;
        if (code == 0) {
          this.$refs.siruiTable.setPageTotal(data.total);
          this.tableData = Object.freeze(data.records);
        } else {
          this.$message.error('查询表格数据失败');
        }
      },
    },
    watch: {
      $route() {
        this.getTableData(); // 监听路由变动调用接口
      },
    },
    components: {
      WithdrawalDialog,
      ApprovalDialog,
      CloseContractDialog,
      ChangPrimaryDialog,
    },
  };
</script>
